module.exports = __webpack_public_path__ + "img/evolucio.e473aef2.svg";